import { createStore as originalCreateStore } from 'redux';
import { accountReducer, AccountState } from './reducers';
import memes from '../../memes';

export const createAccountStore = memes((initialState?: AccountState) => {
	return originalCreateStore(accountReducer, initialState);
});

export * from './communications';
